module.exports = __webpack_public_path__ + "img/porte verriere.f55669e6.jpg";